import React from 'react'
import OnVisible from 'react-on-visible'
import './styles.scss'

const Soundcloud = (props) => {
  const { data } = props
  const { primary } = data
  const { soundcloud } = primary
  const soundcloudHtml = soundcloud?.html

  return (
    <OnVisible>
      {soundcloudHtml && (
        <div className="soundcloud-iframe-container" dangerouslySetInnerHTML={{ __html: soundcloudHtml }} />
      )}
    </OnVisible>
  )
}

export default Soundcloud
